module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1191.e6955315.png";